module.exports = __webpack_public_path__ + "static/img/首页banner2.07fffae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/首页banner2.png
// module id = qI+b
// module chunks = 192